export default __webpack_public_path__ + "static/media/image2.e74d614e.jpg";